import Image from 'next/image'
import { useCustomLogo } from '@omnea-app/fe-files/useCustomLogo'
import { CustomIntegration } from '@omnea-app/packages/universal/extopsApiClient/integrationTypes'
import { globalIntegrationsMetadata } from '@omnea-app/packages/universal/integrations/globalIntegrations'

interface Props {
  customIntegration: CustomIntegration
}

export const CustomHttpIntegrationIcon = ({ customIntegration }: Props) => {
  const { signedUrl } = useCustomLogo({ filestoreId: customIntegration.logo })
  const logoSrc = signedUrl || globalIntegrationsMetadata.http.logo

  return <Image src={logoSrc} alt={customIntegration.name} width={16} height={16} />
}
